module.exports = __webpack_public_path__ + "static/media/paraicon.fe3d0ed3.svg";